(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetKmlDumpDialogController", AssetKmlDumpDialogController);

        AssetKmlDumpDialogController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "Report",
        "AllCaseTypes",
        "UserMasterGeofences",
        "MiniGeofencesByMasterID",
        "AssetType",
        "BaseUrl",
        "myservice"
    ];
    
    function AssetKmlDumpDialogController(
        $timeout,
        $state,
        $scope,
        Report,
        AllCaseTypes,
        UserMasterGeofences,
        MiniGeofencesByMasterID,
        AssetType,
        BaseUrl,
        myservice
    ) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.searchMini = "";
        vm.report;
        vm.geofences = [];
        vm.userMasterGeofences = [];
        vm.geofenceMini;
        vm.selectedMasterGeofenceId = 0;
        vm.selectedGeofenceId;
        vm.entity = 'Assets';
        vm.entityLayout = 'SPREAD';
        vm.entityFileFormat = 'KML';
        vm.showMessage = false;
        vm.showMessageError = false;
        vm.trackingId;
        //vm.submit = true;
        vm.entityTask='DOWNLOAD';

        $(".select2").select2(); // Added search for select box
        vm.users = loadPage();
        $(".select2").change(function () {
            vm.showMessage = false;
            vm.showMessageError = false;
            //vm.submit = true;
        });

        function loadPage() {

            AssetType.query(
                {
                    page: 0,
                    size: 100,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
            }
            function onSuccess(data, headers) {
                vm.assetTypesData = data;
                vm.assetTypes = [];
                vm.assetTypesData.filter(function(val){
                    if(val.layout  == "SPREAD"){
                        vm.assetTypes.push({name: val.name, id: val.id});
                    }
                });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                        });
                    }
                );
            });
            AllCaseTypes.getAll(function (response) {
                vm.caseTypes = response;
            });
        }

        $scope.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            //vm.submit = true;
            vm.geofenceMini = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );

        };


        $scope.entityDump = function () {
            //vm.submit = false;
            if (vm.entity == "Assets") {
                var geofenceDTO = vm.selectedGeofenceId;
                var geofenceId = geofenceDTO;
                    if(geofenceDTO.length == 0){
                        geofenceId = [];
                        geofenceId.push({"id":parseInt(vm.selectedMasterGeofenceId)});
                    }
                    
                    Report.downloadKmlAssetReport(
                        {
                            entityName : vm.entity,
                            geofences: geofenceId,
                            task: vm.entityTask,
                            source: vm.entitySource
                        },
                        function (response) {
                            var a = document.createElement("a");
                            a.style = "display: none";
                            var file = new Blob([(response)], { type: 'application/text' });
                            var fileURL = URL.createObjectURL(file);
                            a.href = fileURL;
                            a.download = vm.entity + ".kml";
                            a.click();
                            window.URL.revokeObjectURL(fileURL);
                        }
                    );
            } else {
                alert("Please select valid entity!");
            }
        };
    }
})();
